const listeners = function(){
    var accordionbuttons = document.querySelectorAll('.accordion-button');
    if(accordionbuttons !==null){
        accordionbuttons.forEach(button=>{
            button.addEventListener('click', function handleAccordion(){
                button.parentElement.nextElementSibling.classList.toggle('d-block')
                button.classList.toggle('active-accordion-button')
            })
        });
    }

    var activeAccordionButtons = document.querySelectorAll('.accordion.active .accordion-button');
    if(activeAccordionButtons !==null){
        activeAccordionButtons.forEach(button=>{
            button.addEventListener('click', function handleAccordion(){
                button.parentElement.nextElementSibling.classList.toggle('d-none')
                button.classList.toggle('inactive-accordion-button')
            })
        });
    }

    var popUpButtons = document.querySelectorAll('.popup-trigger');
    if(popUpButtons !==null){
        popUpButtons.forEach(button=>{
            button.addEventListener('click', function handlePopup(){
            var targetElement = document.getElementById(button.getAttribute('data-modalid'))
            if(targetElement !==null){
                targetElement.classList.toggle('d-block')
                targetElement.classList.toggle('openPopup')
            }})
        });
    }

    var closePopUpButtons = document.querySelectorAll('.close-popup');
    if(closePopUpButtons !==null){
        closePopUpButtons.forEach(button=>{
            button.addEventListener('click', function handleCancel(){
                var targetElement =  document.getElementById(button.getAttribute('data-modalid'))
                if(targetElement !==null){
                targetElement.classList.remove('d-block')
                targetElement.classList.remove('openPopup')
                }
            })
        });
    }

    var sidebarToogler = document.querySelectorAll('.sidebar-toogle-button');
    if(sidebarToogler !== null){
    sidebarToogler.forEach(button=>{
        button.addEventListener('click', function open(){
        button.classList.toggle('cancel-bar')
        var targetElement = document.getElementById(button.getAttribute('data-collapse'))
        if(targetElement !== null){
            targetElement.classList.toggle('openbar')
        }})
    });
    }

    var navbarToogler = document.querySelectorAll('.navbar-toogle-button');
    if(navbarToogler !== null){
    navbarToogler.forEach(button=>{
        button.addEventListener('click', function open(){
        button.classList.toggle('cancel-bar')
        var targetElement =  document.getElementById(button.getAttribute('data-collapse'))
        if(targetElement !== null){
        targetElement.classList.toggle('openbar')
        }})
    });
    }
}

window.addEventListener('load', function() {
    setTimeout(listeners, 100)
 });
